import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  padding: theme.spacing(0, 1),
  marginTop: "10px",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
}));

export const DrawerBody = styled(Box)`
  height: 100%;
  padding: 20px;
  overflow: scroll;
`;

export const DrawerDivider = styled(Box)`
  background-color: ${({ theme }) => theme.palette.divider};
  height: 8px;
`;

export const EmptyBox = styled(Box)`
  width: 10px;
`;
